package com.shadowings.gero.data.lessons.chapter1

import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import gero.composeapp.generated.resources.*

fun getIntroHieroglyphs2QuizContent(): List<IQuizContent> {
    val quizList = mutableListOf<IQuizContent>()
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_fonogrammi,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_monolitteri,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_bilitteri,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_trilitteri,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_monolitteri_soli,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_ideogrammi,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_trattino,
            correct = false
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_consonanti,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_vocali_e,
            correct = true
        )
    )
    quizList.add(
        TrueFalseContent(
            text = Res.string.quiz_intro_hiero2_nessun_nome,
            correct = false
        )
    )
    return quizList.shuffled()
}

fun getIntroHieroglyphs2Content(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_i_tipi_di_segni,
            content = Res.string.exp_content_in_questa_sezione_vedremo_i_diversi_tipi_di_s,
            face = Faces.Idle,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_tipi_di_segni,
            content = Res.string.exp_content_esistono_diversi_tipi_di_segni_n_n_fonogrammi,
            face = Faces.Surprised,
            imageSize = 0.5f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_fonogrammi,
            content = Res.string.exp_content_i_fonogrammi_rappresentano_suoni_n_npossono_e,
            face = Faces.Happy,
            image = Res.drawable.uni_bi_tri,
            imageSize = 0.85f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_gli_ideogrammi,
            content = Res.string.exp_content_alcuni_simboli_possono_essere_usati_anche_com,
            face = Faces.Surprised,
            imageSize = 0.4f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_gli_ideogrammi,
            content = Res.string.exp_content_in_questo_caso_invece_di_indicare_un_suono_in,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_gli_ideogrammi,
            content = Res.string.exp_content_quando_un_segno_usato_come_ideogramma_si_aggi,
            face = Faces.Serious,
            image = Res.drawable.ideograms,
            imageSize = 0.5f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_determinativi,
            content = Res.string.exp_content_i_simboli_determinativi_servono_a_chiarire_il,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_determinativi,
            content = Res.string.exp_content_in_genere_si_mettono_alla_fine_della_parola_m,
            face = Faces.Idle,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_determinativi,
            content = Res.string.exp_content_i_geroglifici_rappresentano_solo_consonanti_e,
            face = Faces.Serious,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_determinativi,
            content = Res.string.exp_content_ovviamente_le_vocali_esistevano_ma_non_veniva,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_determinativi,
            content = Res.string.exp_content_queste_due_parole_ad_esempio_contengono_le_st,
            face = Faces.Serious,
            image = Res.drawable.hy,
            imageSize = 0.85f,
        ),
        ExplanationContent(
            title = Res.string.exp_title_i_determinativi,
            content = Res.string.exp_content_sicuramente_avevano_vocali_diverse_messe_qua_,
            face = Faces.Sad,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_vocali,
            content = Res.string.exp_content_per_convenzione_le_vocali_che_non_conosciamo_,
            face = Faces.Happy,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_vocali,
            content = Res.string.exp_content_per_molti_nomi_per_sappiamo_la_pronuncia_orig,
            face = Faces.Surprised,
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_fine_della_spiegazione,
            face = Faces.Perfect,
        )
    )
}
